<template>
  <AuxiliaryList
    :items="contactLensTestMaterials"
    typeName="material"
    :deleteMutation="deleteItem"
    :saveMutation="save"
    :refreshList="refreshList"
  />
</template>

<script>
  import AuxiliaryList from "@/components/config/contact_len/auxiliary/list.vue";

  export default {
    name: "ContactLenMaterialConfig",
    components: {
      AuxiliaryList,
    },
    apollo: {
      contactLensTestMaterials: {
        query: require("@/graphql/contact_lens_test/materials.gql"),
        pollInterval: 20000,
      },
    },
    methods: {
      deleteItem({ id }) {
        return this.apolloMutate({
          mutation: require("@/graphql/contact_lens_test/delete_contact_lens_material.gql"),
          variables: {
            contactLensMaterialId: id,
          },
        });
      },
      save({ id, name }) {
        return this.apolloMutate({
          mutation: require("@/graphql/contact_lens_test/save_contact_lens_material.gql"),
          variables: {
            contactLensMaterialId: id,
            name: name,
          },
        });
      },
      refreshList() {
        return this.$apollo.queries.contactLensTestMaterials.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
